// ServicesShowcaseSection.js
import React from "react";
import alzheimersCareImage from "../assets/alzheimers-care-showcase.jpg";
import personalCareImage from "../assets/personal-care-showcase.jpg";

const ServicesShowcaseSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto space-y-16">
        {/* Alzheimer's & Dementia Care */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={alzheimersCareImage}
              alt="Elderly woman with dementia"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Alzheimer's & Dementia Care
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                If they aren't a safety risk to themselves or others, helping a
                senior family member with dementia stay in their home can be
                highly beneficial. The committed, highly qualified caregivers at
                Allawah Lodge can assist clients with Alzheimer's or dementia in
                the comfort of their private residences. In addition to helping
                the patient feel safe and secure – reducing the likelihood of
                anxiety or confusion episodes – our Alzheimer's and Dementia
                Care services relieve the family's responsibilities so they can
                stay untroubled.
              </p>

              <p>
                Delivered with patience, empathy, and nurturing, our
                compassionate in-home dementia caregivers are trained to support
                clients and families in these ways:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Continuity of Care</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Familiar Frame of Reference</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Meal Preparation & Assistance</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Low-Stress Environment</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Personal Care */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Personal Care
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Most of us wake up and start our days using the bathroom,
                bathing, dressing, and grabbing a bite to eat. For many seniors,
                this morning routine is not so easy as they struggle to perform
                basic activities of daily living (ADLs). To assist your efforts,
                the home care aides from Allawah Lodge offer reliable and
                discreet personal caregiving assistance for seniors.
              </p>

              <p>
                Conveniently available 24 hours a day, 7 days a week, our
                customised Personal Care solutions include the following:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Bathing & Showering</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Transfer & Ambulation Assistance</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Toileting & Incontinence Care</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Oral Hygiene</span>
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={personalCareImage}
              alt="Caregiver assisting elderly woman with walker"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcaseSection;
